"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.skinComparisonService = exports.skingptService = exports.calendarService = exports.authenticationService = exports.epsService = exports.feedbackService = exports.hairService = exports.skinService = exports.cameraService = exports.weatherService = exports.videoService = exports.recommendationService = exports.profileService = exports.pdfService = exports.binService = exports.analyticsService = void 0;
exports.analyticsService = __importStar(require("./analytics-services/analytics.service"));
exports.binService = __importStar(require("./bin-services/bin.services"));
exports.pdfService = __importStar(require("./pdf-services/pdf-service"));
exports.profileService = __importStar(require("./profile-services/profile.service"));
exports.recommendationService = __importStar(require("./recommendation-services/recommendation.service"));
exports.videoService = __importStar(require("./video-services/video.services"));
exports.weatherService = __importStar(require("./weather-services/weather.services"));
exports.cameraService = __importStar(require("./camera-services/camera.service"));
exports.skinService = __importStar(require("./skin-services/skin.service"));
exports.hairService = __importStar(require("./hair-services/hair.service"));
exports.feedbackService = __importStar(require("./feedback-services/feedback.service"));
exports.epsService = __importStar(require("./eps-services/eps.service"));
exports.authenticationService = __importStar(require("./auth-services/auth.service"));
exports.calendarService = __importStar(require("./calendar-services/calendar.service"));
exports.skingptService = __importStar(require("./skingpt-services/haut.skingpt.service"));
// export * as calendarService from './calendar-services/calendar.service';
var skin_comparison_service_1 = require("./skin-comparison-service/skin-comparison-service");
Object.defineProperty(exports, "skinComparisonService", { enumerable: true, get: function () { return __importDefault(skin_comparison_service_1).default; } });
